<template>
	<Layout :hideCreatePrescriptionBtn="true" >
        <div class="container" style="max-width:480px;" >


            <div class="card mb-3" v-if="loggedMedic.status!='ACTIVE'">
				<div class="card-body" >
					<div class="alert alert-warning text-center">
						Médico inhabilitado para prescribir
					</div>
				</div>
			</div>
            <div v-if="loggedMedic.status=='ACTIVE'">

                <PrescriptionForm />
            </div>
        </div>
            
    </Layout>
</template>

<script>
import { mapGetters} from "vuex"
import PrescriptionForm from './PrescriptionForm'
export default {
    name: 'PrescriptionFormPage',
    components: { PrescriptionForm },
    computed: {
		...mapGetters(["loggedMedic", "menuOpen"])
	},
    data() {
        return {
            list:[],
            loading:true,
        }
    },
    
}
</script>

<style scoped>

</style>
